import { useContext, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import { AuthContext } from "../contexts/AuthContext";
import NavbarLink from "./NavbarLink";
import UserProfilePhoto from "./UserProfilePhoto";

import ROLES from "../data/roles";

import { BuildingOffice2Icon, UsersIcon, UserMinusIcon, LifebuoyIcon, SpeakerWaveIcon, BriefcaseIcon, PencilIcon, ChevronDownIcon, ClockIcon, UserPlusIcon, QrCodeIcon } from "@heroicons/react/24/outline";
import ASELogo from "../assets/ase-logo.png";

const AdminLinks = ({ onBroadcastClicked }) => {
  const [isLabourDropdownOpen, setIsLabourDropdownOpen] = useState(false);

  const location = useLocation();

  useEffect(() => {
    setIsLabourDropdownOpen(false);
  }, [location]);

  return (
    <>
      <NavbarLink to="/admin/design-and-engineering" label="Design & Engineering" icon={<PencilIcon className="h-5 w-5 text-ase-blue" />} end={false} />

      <div className="relative">
        <button
          onClick={e => setIsLabourDropdownOpen(!isLabourDropdownOpen)}
          className="text-lg md:text-sm px-2 py-2 md:py-1 flex items-center gap-2 md:gap-1 hover:text-ase-blue transition-all"
        >
          <UsersIcon className="h-5 w-5 text-ase-blue" /> Labour <ChevronDownIcon className="h-5 w-5 text-ase-blue" />
        </button>

        {isLabourDropdownOpen && (
          <div className="flex flex-col gap-2 absolute top-12 left-0 bg-white p-2 z-10 shadow-lg whitespace-nowrap">
            <NavbarLink
              to="/admin/projects"
              label="Projects"
              icon={<BuildingOffice2Icon className="h-5 w-5 text-ase-blue" />}
            />

            <NavbarLink
              to="/admin/labour"
              label="Labourers"
              icon={<UsersIcon className="h-5 w-5 text-ase-blue" />}
            />

            <NavbarLink
              to="/admin/allocations"
              label="Allocations"
              icon={<BriefcaseIcon className="h-5 w-5 text-ase-blue" />}
            />

            <NavbarLink
              to="/admin/time-entries"
              label="Time entries"
              icon={<ClockIcon className="h-5 w-5 text-ase-blue" />}
            />

            <NavbarLink
              to="/admin/leave-requests"
              label="Leave Requests"
              icon={<UserMinusIcon className="h-5 w-5 text-ase-blue" />}
            />

            <NavbarLink
              to="/admin/potential-hires"
              label="Potential Hires"
              icon={<UserPlusIcon className="h-5 w-5 text-ase-blue" />}
            />

            <NavbarLink
              to="/admin/clocked-in"
              label="Clocked In"
              icon={<QrCodeIcon className="h-5 w-5 text-ase-blue" />}
            />
          </div>
        )}
      </div>

      <NavbarLink to="/admin/support" label="Support" icon={<LifebuoyIcon className="h-5 w-5 text-ase-blue" />} />

      <SpeakerWaveIcon
        onClick={onBroadcastClicked}
        className="h-[20px] hover:text-ase-blue cursor-pointer"
      />
    </>
  )
}

const AdminNavbar = ({ onBroadcastClicked }) => {
  const { user } = useContext(AuthContext);

  return (
    <nav className="hidden md:flex justify-center py-4 shadow-md overflow-visible">
      <div className="container flex items-center justify-between">
        <Link to={user?.role === ROLES.ADMIN ? "/admin" : "/"}>
          <img src={ASELogo} alt="ASE Group" className="h-[30px]" />
        </Link>

        <div className="flex items-center gap-2">
          <AdminLinks onBroadcastClicked={onBroadcastClicked} />

          <Link to="/admin/profile" className="ml-4">
            <UserProfilePhoto
              photoUrl={user?.profilePicture}
              fullName={user?.fullName}
            />
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default AdminNavbar;
